// --- React
import React from "react";
// --- Styles
import "./styles.scss";

/**
 * FormCard Component
 *
 * A card wrapper for form content with consistent styling.
 * Used in create/edit drawers to group related form fields.
 *
 * @component
 * @param {Object} props - Component properties
 * @param {React.ReactNode} props.children - Content to display inside the card
 * @param {string} [props.className] - Additional CSS class names
 * @param {Object} [props.style] - Inline styles to apply
 * @returns {JSX.Element}
 *
 * @example
 * <FormCard>
 *   <Input label="Name" value={name} onChange={setName} />
 *   <Select label="Status" options={statusOptions} />
 * </FormCard>
 *
 * @example
 * // With custom styling
 * <FormCard className="highlight" style={{ marginTop: 16 }}>
 *   <Input label="Description" />
 * </FormCard>
 */
export const FormCard = ({ children, className = "", style = {} }) => {
  const classNames = ["form-card", className].filter(Boolean).join(" ");
  return (
    <div className={classNames} style={style}>
      {children}
    </div>
  );
};

export default FormCard;
